import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';
import SearchActions from 'app/actions/SearchActions';
import { scopeShape } from 'app/shapes/search';
import SearchScopeField from './SearchScopeField';

const mapStateToProps = state => ({
  scopes: selectCurrentSiteScopes(state),
  currentSearchScope: state.getIn(['search', 'catalogSearch', 'scope'])
});

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch)
});

const SearchScopeFieldContainer = ({ scopes, currentSearchScope }) => {
  if (scopes.size <= 1) {
    return null;
  }

  return <SearchScopeField scopes={scopes} currentSearchScope={currentSearchScope} />;
};

SearchScopeFieldContainer.propTypes = {
  scopes: ImmutablePropTypes.listOf(scopeShape),
  currentSearchScope: PropTypes.string
};

SearchScopeFieldContainer.displayName = 'SearchScopeFieldContainer';
export default connect(mapStateToProps, mapDispatchToProps)(SearchScopeFieldContainer);
